function notAStringError(not_a_str) {
	throw new TypeError(
		"Expected a value of type string but got a value of type " +
			typeof not_a_str,
	);
}

function shield(func) {
	return function (str) {
		if (typeof str !== "string") notAStringError(str);
		str = str.trim();
		return str ? func(str) : null;
	};
}

export { shield, notAStringError };
